import React from "react";

import Logo from './logo.png';

import { withStyles } from "@mui/styles";
import { withRouter }  from "react-router-dom";
// import withRouter  from 'adds/router/withRouter.js';


import {  Paper,
          Box,
          
} from '@mui/material';

const useStyles = {
  root: {
    background: 'linear-gradient(to top left, #FF7043, #2E7D32)',
    heigth:"100vh"

  },
  logo: {
    maxHeight: 80,
    maxWidth: 190,
    paddingLeft: 10,
    paddingTop: 10
  },
  // appBarSpacer: theme.mixins.toolbar,
  content: {
    maxWidth: 300,
  },
  container: {
    paddingTop: 4,
    paddingBottom: 4,
  },
  paper: {
    padding: 2,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },

};

class LoginLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };


  }
  render() {
    return (
    <Box  className={this.props.classes.root}>
      <Box  display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            
      >
        
          <Paper elevation={3}>

            <Box p={2} className={this.props.classes.content}>
              <Box>
                <img src={Logo} alt='AxonRt' className={this.props.classes.logo}/>
              </Box>
            </Box>
            <Box p={3}>
              {this.props.children}
            </Box>
          </Paper>
        </Box>
      

    </Box>
    );
  }
}

export default withRouter(withStyles(useStyles, { withTheme: true })(LoginLayout));
